import styled from 'styled-components';

export const CmsReactionsContainer = styled.div`
  border-radius: 4px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.18);
`;

export const CmsReactionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 20px;
  gap: 40px;
`;

export const CmsReactionsSummaryContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`;

export const CmsReactionsUserEngagementBar = styled.div`
  display: flex;
  gap: 28px;
`;

export const CmsReactionsButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
`;
